import { COLORS } from '@constants';
import { Button, Input, Select } from '@ui';
import { Modal, Typography } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
    padding: 24px;
    position: fixed;
    top: ${({ $customTop }) => ($customTop ? `${$customTop}px` : '164px')};
    left: ${({ $customLeft }) => ($customLeft ? `${$customLeft}px` : '29.2%')};
    transform: ${({ $customLeft }) => ($customLeft ? 'none' : 'translateX(-50%, 0%)')};

    .ant-modal-close {
        top: 24px;
        right: 24px;
    }

    .ant-modal-close:hover {
        background-color: transparent !important;
    }
`;

export const DividerLine = styled.div`
    width: 100%;
    height: 1px;
    background: ${COLORS.$gray15Black};
`;

export const StyledTypographyHeader = styled(Typography.Text)`
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
    color: ${COLORS.$gray100Black};
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const InputField = styled(Input)`
    &&& {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 4px 16px;
        gap: 10px;
        height: 56px;
        background: ${COLORS.$white};
        border: 1px solid ${COLORS.$gray20Black};
        border-radius: 8px;

        input {
            width: 100%;
            height: 24px;
            font-size: 16px;
            line-height: 24px;
            font-weight: 400;
            color: ${COLORS.$gray100Black};
            flex: 1;
            display: flex;
            align-items: center;
        }

        &::placeholder {
            color: ${COLORS.$gray40Black};
        }
    }
`;

export const SelectField = styled(Select)`
    &&& {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 4px 16px;
        gap: 16px;
        height: 56px;
        background: ${COLORS.$gray20Black};
        border: 2px solid ${COLORS.$gray15Black};
        border-radius: 8px;

        &.ant-select-disabled {
            background: ${COLORS.$gray20Black};
            border: 2px solid ${COLORS.$gray15Black};
        }

        .ant-select-selector {
            background: transparent !important;
            border: none !important;
            height: 56px !important;
            padding: 0px !important;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 2px;
            flex: 1;
        }

        .ant-select-selection-placeholder {
            color: ${COLORS.$gray40Black};
            font-size: 12px;
            line-height: 16px;
            font-weight: 500;
            text-align: left;
        }

        .ant-select-selection-item {
            color: ${COLORS.$gray100Black};
            font-size: 16px;
            line-height: 24px;
            font-weight: 400;
            text-align: left;
            display: flex;
            align-items: center;
        }

        .ant-select-arrow {
            width: 24px;
            height: 24px;
        }
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 16px;
    justify-content: flex-end;
    width: 100%;
`;

export const CancelButton = styled(Button)`
    &&& {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0px 16px;
        gap: 8px;
        width: 160px;
        height: 56px;
        background: ${COLORS.$white};
        border: 2px solid ${COLORS.$gray20Black};
        border-radius: 8px;
        color: ${COLORS.$gray60Black};
        font-size: 16px;
        line-height: 24px;
        font-weight: 500;
        text-align: center;

        &:hover {
            background: ${COLORS.$white};
            border-color: ${COLORS.$gray20Black};
            color: ${COLORS.$gray60Black};
        }

        &:active {
            background: ${COLORS.$white};
            border-color: ${COLORS.$gray20Black};
            color: ${COLORS.$gray60Black};
        }
    }
`;

export const SendInviteButton = styled(Button)`
    &&& {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0px 16px;
        gap: 8px;
        width: 160px;
        height: 56px;
        background: ${COLORS.$pinkGradient};
        border: 2px solid ${COLORS.$pink};
        border-radius: 8px;
        color: ${COLORS.$white};
        font-size: 16px;
        line-height: 24px;
        font-weight: 500;
        text-align: center;

        &:hover {
            background: ${COLORS.$pinkGradient};
            border-color: ${COLORS.$pink};
            opacity: 0.9;
        }

        &:active {
            background: ${COLORS.$pinkGradient};
            border-color: ${COLORS.$pink};
        }
    }
`;

export const StyledCloseButton = styled.span.attrs({
    'data-e2e': 'invite-developer_close_icon'
})`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
